module.exports = __webpack_public_path__ + "static/img/UC3880-4K.433ea48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/detailpic/UC3880/UC3880-4K.jpg
// module id = ZwlO
// module chunks = 51